import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';

import { ProjectUpload } from './ProjectUpload';

export const ProjectUploadFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'ProjectUpload',
    component: ProjectUpload,
  }),
);
